import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=1e13e7d2&"
import script from "./IncomingCall.vue?vue&type=script&lang=js&"
export * from "./IncomingCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports